import request from '@/helpers/request'

export default {
  async getQuestions() {
    return await request.get('/survey/questions')
  },
  async submit(data) {
    return await request.post('/survey/submit', data)
  }
}

